export default __webpack_public_path__ + "static/media/CameraH2.b76ee1cc.png";